import superagent from 'superagent';

import currentUser from './current-user';
import { Store } from './';
import { API_URL } from '../Constants';

const createRequest = (url, method, body) => {
  switch (method) {
    case 'HEAD':
      return superagent.head(url, body);
    case 'GET':
      return superagent.get(url, body);
    case 'POST':
      return superagent.post(url, body);
    case 'PUT':
      return superagent.put(url, body);
    case 'PATCH':
      return superagent.patch(url, body);
    case 'DELETE':
      return superagent.delete(url, body);
    default:
      throw new Error(`Unsupported HTTP method: ${method}`);
  }
};

const superagentApiNetworkInterface = (url, method, { body, headers, credentials } = {}) => {
  const request = createRequest(url, method, body);

  if (url.substring(0, API_URL.length) === API_URL) {
    let accessToken = currentUser.selectors.getCurrentUserAccessToken(Store.getState());

    let apiHeaders = {};
    apiHeaders['Content-Type'] = 'application/json';
    if (accessToken) apiHeaders['Authorization'] = `Bearer ${accessToken}`;

    request.set({
      ...headers,
      ...apiHeaders,
    });

    if (credentials === 'include') {
      request.withCredentials();
    }
  }

  const execute = cb =>
    request.end((err, response) => {
      const resStatus = (response && response.status) || 0;
      const resBody = (response && response.body) || undefined;
      const resText = (response && response.text) || undefined;
      const resHeaders = (response && response.header) || undefined;

      cb(err, resStatus, resBody, resText, resHeaders);
    });

  const abort = () => request.abort();

  return {
    abort,
    execute,
    instance: request,
  };
};

export default superagentApiNetworkInterface;



// WEBPACK FOOTER //
// ./src/redux/apiNetworkInterface.js